import React from 'react';
import Select from 'react-select';

const CourseSelect = ({ value, onChange, options, isDisabled, index, isClearable }) => {
  const selectStyles = {
    control: (baseStyles, state) => ({
      ...baseStyles,
      minWidth: 0,
      borderRadius: '32px',
      borderColor: state.isFocused ? '#2667ff' : '#333333',
      boxShadow: state.isFocused ? '0 0 0 1px #2667ff' : 'none',
      padding: '12px',
      cursor: 'pointer',
      '&:hover': {
          borderColor: '#4f46e5'
      }
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? '#2667ff' : 'white',
      color: state.isSelected ? 'white' : '#333333',
      cursor: 'pointer',
      '&:hover': {
          backgroundColor: state.isSelected ? '#2667ff' : '#eef2ff'
      }
  }),
    valueContainer: (baseStyles) => ({
      ...baseStyles,
      overflow: 'hidden',
    }),
    singleValue: (baseStyles) => ({
      ...baseStyles,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      right: 0,
      left: 0,
      position: 'absolute',
    }),
    menu: (baseStyles) => ({
      ...baseStyles,
      width: 'auto',
      minWidth: '100%',
      zIndex: 999,
      borderRadius: '6px',
      boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)',
      border: '1px solid grey',
      padding: '0',
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: 'black',
    }),
    placeholder: (provided) => ({
        ...provided,
        color: 'black'
    })
  };

  return (
    <div style={{ width: '100%', position: 'relative' }}>
      <Select
        value={value}
        onChange={onChange}
        options={options}
        isDisabled={isDisabled}
        isClearable={isClearable}
        placeholder="Search and select a course"
        className="course-select"
        classNamePrefix="select"
        styles={selectStyles}
      />
    </div>
  );
};

export default CourseSelect;
